<perfect-scrollbar
  class="scroll-container"
  [style]="perfectScrollbarHeight"
  [config]="config"
  #contentItemsPerfectScroll
>
  <div
    *ngIf="!contentItems.length && loading"
    class="d-flex justify-content-center text-muted"
  >
    <app-not-records-found
      [visible]="!contentItems.length"
    ></app-not-records-found>
  </div>
  <ul class="p-list-group">
    <li *ngFor="let item of contentItems">
      <div class="p-grid">
        <div class="p-col">
          <div class="p-list-picture">
            <img [src]="item.imageUrl" />
          </div>

          <div class="content-details">
            <div class="p-col-fixed p-0 pt-0">
              <span
                class="star-icon force-pointer"
                (click)="handleSaveContenItem(item)"
              >
                <i [class]="getStarIcon(item)"></i>
              </span>
            </div>
            <div class="coverage-title-wrapper p-col p-0 pt-0">
              <span
                class="coverage-title p-list-title"
                href="javascript:;"
                role="button"
                (click)="goToTitleUrl(item.url)"
                (mouseenter)="showTooltip($event, item.title)"
                (mouseleave)="hideTooltip()"
              >
                <span
                  *ngIf="item.titleExcerpt"
                  [innerHTML]="item.titleExcerpt"
                ></span>
                <span *ngIf="!item.titleExcerpt && item.title">
                  {{ item.title }}
                </span>
              </span>
            </div>
            <div class="p-col-12 p-0">
              <div class="p-list-subtitle">
                {{ item.publishDate | date }}
                <span class="content-party-list">
                  <span class="content-party" *ngIf="item.authorId">
                    <app-star-toggle
                      [active]="isAuthorSaved(item)"
                      [isLoading]="savingAuthorId === item.authorId"
                      (toggled)="onAuthorStarToggled(item, $event)"
                    ></app-star-toggle>
                    <a
                      href="javascript:;"
                      role="button"
                      (click)="getAuthorContent(item)"
                      >{{ item.author }}</a
                    >
                  </span>
                  <span
                    class="content-party"
                    *ngIf="!item.authorId && item.author"
                  >
                    {{ item.author }}
                  </span>
                  <span class="content-party-separator">-</span>
                  <span class="content-party" *ngIf="item.outletId">
                    <app-star-toggle
                      [active]="isOutletSaved(item)"
                      [isLoading]="savingOutletId === item.outletId"
                      (toggled)="onOutletStarToggled(item, $event)"
                    ></app-star-toggle>
                    <a
                      href="javascript:;"
                      role="button"
                      (click)="getOutletContent(item)"
                      >{{ item.outlet }}</a
                    >
                  </span>
                  <span
                    class="content-party"
                    *ngIf="!item.outletId && item.outlet"
                  >
                    {{ item.outlet }}
                  </span>
                </span>
              </div>
              <div class="p-list-text" [innerHTML]="item.bodyExcerpt"></div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <div *ngIf="!loading">
    <app-content-items-skeleton></app-content-items-skeleton>
  </div>
</perfect-scrollbar>

<div
  class="title-tooltip"
  *ngIf="tooltipVisible"
  [style.top.px]="tooltipY"
  [style.left.px]="tooltipX"
>
  {{ tooltipText }}
</div>
